module.exports = __webpack_public_path__ + "static/burgermeister_berggotz-e82452287cd20780232e378c2f1fec4e.jpg";